"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefinitionListIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var mini_icons_1 = require("../mini-icons");
function DefinitionListIcon(props) {
    var type = props.type, color = props.color;
    switch (type) {
        case 'business':
            return react_1.default.createElement(mini_icons_1.MiniIconBusiness, null);
        case 'contact':
            return react_1.default.createElement(mini_icons_1.MiniIconContactCard, null);
        case 'document':
            return react_1.default.createElement(mini_icons_1.MiniIconDocument, null);
        case 'date':
            return react_1.default.createElement(mini_icons_1.MiniIconDate, null);
        case 'dateRange':
            return react_1.default.createElement(mini_icons_1.MiniIconDate, null);
        case 'datetime':
            return react_1.default.createElement(mini_icons_1.MiniIconClock, null);
        case 'currency':
        case 'currency-percentage':
            return react_1.default.createElement(mini_icons_1.MiniIconCurrency, null);
        case 'followUpDate':
            return react_1.default.createElement(mini_icons_1.MiniIconFollowUpDate, { color: color });
        case 'location':
            return react_1.default.createElement(mini_icons_1.MiniIconLocation, null);
        case 'name':
            return react_1.default.createElement(mini_icons_1.MiniIconName, null);
        case 'note':
            return react_1.default.createElement(mini_icons_1.MiniIconNote, null);
        case 'number':
            return react_1.default.createElement(mini_icons_1.MiniIconHash, null);
        case 'email':
            return react_1.default.createElement(mini_icons_1.MiniIconEmail, null);
        case 'phone':
            return react_1.default.createElement(mini_icons_1.MiniIconPhone, null);
        case 'business-alternative':
            return react_1.default.createElement(mini_icons_1.MiniIconBusinessAlternative, null);
        case 'briefcase':
            return react_1.default.createElement(mini_icons_1.MiniIconBriefcase, null);
        case 'pie-chart':
            return react_1.default.createElement(mini_icons_1.MiniIconPieChart, null);
        default:
            return react_1.default.createElement("svg", null);
    }
}
exports.DefinitionListIcon = DefinitionListIcon;
//# sourceMappingURL=definition-list-icons.js.map